import React from 'react';
import { FiveElementsCircle } from '../components/FiveElementsCircle';
import { InteractiveQuiz } from '../components/InteractiveQuiz';
import { Lightbulb } from 'lucide-react';
export const WuXing: React.FC = () => {
  const quizQuestions = [{
    question: "在五行相生中，'金'生什么？",
    options: ['木', '水', '火', '土'],
    correctAnswer: 1,
    explanation: '金生水。金属熔化成液态，或金属表面凝结水珠，古人以此取象。'
  }, {
    question: "在五行相克中，'水'克什么？",
    options: ['木', '火', '土', '金'],
    correctAnswer: 1,
    explanation: '水克火。水能灭火，这是最直观的自然现象。'
  }];
  return <div className="space-y-12" data-id="element-406">
      <div className="text-center mb-10" data-id="element-407">
        <h1 className="text-3xl font-serif font-bold text-gold-dark mb-4" data-id="element-408">
          五行生克
        </h1>
        <p className="text-ink-light" data-id="element-409">木火土金水，宇宙万物运行的基本法则。</p>
      </div>

      <div className="bg-gold/5 border border-gold/20 p-6 rounded-lg flex gap-4 items-start" data-id="element-410">
        <div className="bg-gold/20 p-2 rounded-full text-gold-dark shrink-0" data-id="element-411">
          <Lightbulb size={24} data-id="element-412" />
        </div>
        <div data-id="element-413">
          <h3 className="font-serif font-bold text-gold-dark text-lg mb-2" data-id="element-414">
            小白记忆法：自然现象
          </h3>
          <p className="text-ink-light text-sm leading-relaxed" data-id="element-415">
            <strong data-id="element-416">相生（妈妈生孩子）：</strong> 钻木取火（木生火）→
            火烧成灰（火生土）→ 土里挖矿（土生金）→ 金属熔化（金生水）→
            水灌溉树（水生木）。
            <br data-id="element-417" />
            <strong data-id="element-418">相克（警察抓小偷）：</strong> 树根破土（木克土）→
            堤坝挡水（土克水）→ 水能灭火（水克火）→ 火能熔金（火克金）→
            斧头砍树（金克木）。
          </p>
        </div>
      </div>

      <section className="flex flex-col md:flex-row gap-12 items-center" data-id="element-419">
        <div className="flex-1 space-y-6" data-id="element-420">
          <h2 className="text-2xl font-serif text-gold-dark border-l-4 border-gold pl-3" data-id="element-421">
            五行互动图
          </h2>
          <p className="text-ink-light leading-relaxed" data-id="element-422">
            五行不是五种具体的物质，而是五种能量状态。它们之间存在着相互资生（相生）和相互制约（相克）的关系。
            <br data-id="element-423" />
            <br data-id="element-424" />
            <strong data-id="element-425">相生（外圈虚线）：</strong> 顺时针循环，生生不息。
            <br data-id="element-426" />
            <strong data-id="element-427">相克（内圈实线）：</strong> 隔位制约，维持平衡。
          </p>
        </div>
        <div className="flex-1 bg-white ink-border p-8 rounded-lg shadow-sm w-full" data-id="element-428">
          <FiveElementsCircle data-id="element-429" />
        </div>
      </section>

      <section className="space-y-6" data-id="element-430">
        <h2 className="text-2xl font-serif text-gold-dark border-l-4 border-gold pl-3" data-id="element-431">
          五行属性对照表
        </h2>
        <div className="overflow-x-auto bg-white ink-border rounded-lg shadow-sm" data-id="element-432">
          <table className="w-full text-left border-collapse" data-id="element-433">
            <thead data-id="element-434">
              <tr className="border-b border-gold/30 text-gold-dark bg-paper" data-id="element-435">
                <th className="p-4 font-serif" data-id="element-436">五行</th>
                <th className="p-4 font-serif" data-id="element-437">方位</th>
                <th className="p-4 font-serif" data-id="element-438">季节</th>
                <th className="p-4 font-serif" data-id="element-439">颜色</th>
                <th className="p-4 font-serif" data-id="element-440">五脏</th>
                <th className="p-4 font-serif" data-id="element-441">性情</th>
              </tr>
            </thead>
            <tbody className="text-ink-light" data-id="element-442">
              <tr className="border-b border-paper-dark hover:bg-paper transition-colors" data-id="element-443">
                <td className="p-4 font-bold text-element-wood" data-id="element-444">木</td>
                <td className="p-4" data-id="element-445">东</td>
                <td className="p-4" data-id="element-446">春</td>
                <td className="p-4" data-id="element-447">青/绿</td>
                <td className="p-4" data-id="element-448">肝</td>
                <td className="p-4" data-id="element-449">仁慈、向上</td>
              </tr>
              <tr className="border-b border-paper-dark hover:bg-paper transition-colors" data-id="element-450">
                <td className="p-4 font-bold text-element-fire" data-id="element-451">火</td>
                <td className="p-4" data-id="element-452">南</td>
                <td className="p-4" data-id="element-453">夏</td>
                <td className="p-4" data-id="element-454">赤/红</td>
                <td className="p-4" data-id="element-455">心</td>
                <td className="p-4" data-id="element-456">热情、礼仪</td>
              </tr>
              <tr className="border-b border-paper-dark hover:bg-paper transition-colors" data-id="element-457">
                <td className="p-4 font-bold text-element-earth" data-id="element-458">土</td>
                <td className="p-4" data-id="element-459">中</td>
                <td className="p-4" data-id="element-460">四季末</td>
                <td className="p-4" data-id="element-461">黄/棕</td>
                <td className="p-4" data-id="element-462">脾</td>
                <td className="p-4" data-id="element-463">稳重、诚信</td>
              </tr>
              <tr className="border-b border-paper-dark hover:bg-paper transition-colors" data-id="element-464">
                <td className="p-4 font-bold text-element-metal" data-id="element-465">金</td>
                <td className="p-4" data-id="element-466">西</td>
                <td className="p-4" data-id="element-467">秋</td>
                <td className="p-4" data-id="element-468">白</td>
                <td className="p-4" data-id="element-469">肺</td>
                <td className="p-4" data-id="element-470">刚毅、义气</td>
              </tr>
              <tr className="hover:bg-paper transition-colors" data-id="element-471">
                <td className="p-4 font-bold text-element-water" data-id="element-472">水</td>
                <td className="p-4" data-id="element-473">北</td>
                <td className="p-4" data-id="element-474">冬</td>
                <td className="p-4" data-id="element-475">黑/蓝</td>
                <td className="p-4" data-id="element-476">肾</td>
                <td className="p-4" data-id="element-477">智慧、灵动</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section className="mt-16" data-id="element-478">
        <InteractiveQuiz questions={quizQuestions} data-id="element-479" />
      </section>
    </div>;
};